import { createContext } from "react";

export interface SelectedStation {
  labId: undefined | number;
  stationId: undefined | number;
  setLabId(labId: number): void;
  setStationId(stationId: number): void;
  unset(): void;
}

const SelectedStationContext = createContext<SelectedStation>({
  labId: undefined,
  stationId: undefined,
  setLabId: (_labId: number) => {},
  setStationId: (_stationId: number) => {},
  unset: () => {},
});

export default SelectedStationContext;
